module.exports = __webpack_public_path__ + "fonts/unicons.257bdf0.ttf";